import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { CollectionFilter } from "../../models/CollectionFilter";
import DashboardFilter from "../DashboardFilter/DashboardFilter.vue";
import {
  FilterField,
  FilterOfCollection
} from "../../models/FilterOfCollection";
import store from "@/store";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  DASHBOARD_CHART_TYPES,
  GENERAL_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { mapGetters } from "vuex";
import lodash from "lodash";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { Field } from "../../models/Field";
import { SectionOfDashboard } from "../../models/SectionOfDashboard";
import { FilterItemOfQuery } from "../../models/FilterItemOfQuery";
import { BqDashboardService } from "../../services/BqDashboardService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import Charts from "../Charts/Charts.vue";
import { DASHBOARD_MESSAGES } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { Http } from "@status/codes";
import ChartTypeMenu from "../ChartTypeMenu/ChartTypeMenu.vue";
import {
  DASHBOARD_TEMPLATE_EVENTS,
  DASHBOARD_TEMPLATE_MESSAGES,
  DATA_TYPE,
  FIELD_WITHOUT_DATA_ID,
  SEE_BY_LIST
} from "../../constants/DashboardTemplatesConstants";
import { Query } from "../../models/Query";
import { IndicatorOrTag } from "../../models/IndicatorOrTag";

@Component({
  name: "CollectionOfSection",
  components: {
    DynamicSelect,
    DashboardFilter,
    Charts,
    EmptyState,
    ChartTypeMenu
  },
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      eventChart: "getEventChart"
    })
  }
})
export default class CollectionOfSection extends Vue {
  @Inject() bqDashboardService!: BqDashboardService;
  @Prop() indexCollectionFilter!: number;
  @Prop() indexSectionOfDashboard!: number;
  @Prop() collectionFilter!: CollectionFilter;
  @Prop() collectionsOptions!: { id: string; name: string; fields?: Field[] }[];

  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  eventChart!: {
    indexSection: number;
    indexCollection: number;
    values: string | string[];
    chartType: string;
  };

  filters: FilterOfCollection[] = [];
  collectionField = [] as DynamicSelectData[];
  collectionsOptionsConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    required: true,
    hideDetails: false
  };
  configChartForm = false;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  addItem = GENERAL_CONSTANTS.ICONS.ADD;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  chartOptions = {};
  refreshFilters = 0;
  showDialogConfigChart = false;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  EMPTY_STATE_HEADER = DASHBOARD_MESSAGES.NO_RESULTS;
  EMPTY_STATE_PARAGRAPH = DASHBOARD_MESSAGES.NOT_FOUND;
  groupBy = [] as DynamicSelectData[];
  groupByOptionsConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: DASHBOARD_TEMPLATE_MESSAGES.GROUP_BY,
    hideDetails: false,
    attach: false,
    limit: 3,
    required: true
  };
  seeBy = [] as DynamicSelectData[];
  seeByOptionsConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: lodash.cloneDeep(SEE_BY_LIST),
    filled: false,
    messageLabel: DASHBOARD_TEMPLATE_MESSAGES.SEE_BY,
    hideDetails: false,
    attach: false,
    required: true
  };
  chartName = "";
  showCharts = false;
  firstQueryExecuted = false;
  propertiesToChart = {};
  foundData = true;
  showSeeBy = false;
  searching = false;
  chartType = "";
  reloadChartTypeMenu = 0;
  chartColor = { hex: "" };
  mounted() {
    this.preloadData();
  }
  preloadData() {
    const collectionFilter = lodash.cloneDeep(
      this.sectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
        this.indexCollectionFilter
      ]
    );

    this.collectionField = collectionFilter.collection;
    this.collectionsOptionsConfig.listAll = lodash.cloneDeep(
      this.collectionsOptions
    );
    this.chartName = collectionFilter.chartName;
    this.filters = lodash.cloneDeep(this.collectionFilter.filters);

    this.chartColor = { hex: collectionFilter.chartColor as string };

    this.chartType = collectionFilter.chartType;

    this.groupByOptionsConfig.listAll = this.collectionsOptions
      .find(collection => collection.id == collectionFilter.collection[0].id)
      ?.fields!?.map(item => {
        return { id: item.field, name: item.visualField, type: item.type };
      }) as DynamicSelectData[];

    if (!collectionFilter.query) return;

    this.groupBy =
      this.groupByOptionsConfig.listAll?.filter(option =>
        (collectionFilter.groupBy as string[]).includes(option.id)
      ) || [];

    this.seeBy =
      this.seeByOptionsConfig.listAll?.filter(
        option => option.id == (collectionFilter.seeBy as DynamicSelectData).id
      ) || [];

    this.makeQueryWhenIsPreloading(collectionFilter.query as Query);
  }

  @Watch("collectionsOptions")
  onCollectionsOptionsChange() {
    // console.log('onCollectionsOptionsChange', this.collectionsOptions);
    //this.collectionField = lodash.cloneDeep(this.collectionFilter.collection);
    /*   if (this.collectionField.length > 0) {
        this.collectionsOptionsConfig.listAll = lodash
          .cloneDeep(this.collectionsOptions)
          .concat(this.collectionField[0]);
        return;
      }
  
      this.collectionsOptionsConfig.listAll = lodash.cloneDeep(
        this.collectionsOptions
      ); */
  }

  @Watch("indexCollectionFilter")
  onIndexCollectionFilterChange() {
    // Re-cargar los datos con el nuevo índice
    this.preloadData();
  }

  @Watch("collectionFilter")
  onCollectionFilterChange() {
    /*   const hasFilterFromChart = this.filters.some(
      filter => filter.filterFromChart
    ); */
    this.collectionField = lodash.cloneDeep(this.collectionFilter.collection);
    /*  if (!hasFilterFromChart) {
       this.filters = lodash.cloneDeep(this.collectionFilter.filters);
       console.log('filters from chart ', this.filters);
     } */

    this.groupByOptions();
    const copySectionsOfDashboardStore = lodash.cloneDeep(
      this.sectionsOfDashboardStore
    );

    this.groupBy = copySectionsOfDashboardStore[this.indexSectionOfDashboard]
      .collections[this.indexCollectionFilter].groupBy as DynamicSelectData[];
    this.seeBy = copySectionsOfDashboardStore[this.indexSectionOfDashboard]
      .collections[this.indexCollectionFilter].seeBy as DynamicSelectData[];
    this.filters = copySectionsOfDashboardStore[this.indexSectionOfDashboard]
      .collections[this.indexCollectionFilter].filters as FilterOfCollection[];
    this.refreshFilters = this.refreshFilters + 1;

    /*  this.propertiesToChart = {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: this.indexCollectionFilter,
      groupBy:
        copySectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
          this.indexCollectionFilter
        ].groupBy,
      chartType:
        copySectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
          this.indexCollectionFilter
        ].chartType,
      chartColor:
        copySectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
          this.indexCollectionFilter
        ].chartColor
    }; */
    this.makeQuery();
  }

  onCollectionFieldChange() {
    store.commit(
      DASHBOARD_TEMPLATE_EVENTS.QUITE_COLLECTION_ITEM_OPTION_AND_PUT_IN_COLLECTION,
      {
        indexSectionOfDashboard: this.indexSectionOfDashboard,
        indexCollectionFilter: this.indexCollectionFilter,
        collection: this.collectionField
      }
    );
    store.commit("setDisabledAddCollectionFilterButton", false);
    this.filters = [];
    this.groupByOptions();
  }

  saveConfigChart() {
    if (this.validateGroupBy()) {
      return Snackbar.popError(DASHBOARD_TEMPLATE_MESSAGES.CANT_GROUP_BY_DATE);
    }
    this.showDialogConfigChart = false;
    this.makeQuery();
  }

  validateGroupBy() {
    return (
      this.groupBy.filter(groupBy => groupBy.type == DATA_TYPE.TIME_STAMP)
        .length == 2
    );
  }

  addFilter() {
    this.filters.push({ field: [], operator: [], value: [] });

    store.commit(DASHBOARD_TEMPLATE_EVENTS.ADD_FILTER, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      index: this.indexCollectionFilter,
      onefilter: { field: [], operator: [], value: [] }
    });
  }

  onFilterDeleted(deletedIndex: number) {
    this.filters.splice(deletedIndex, 1);
  }

  deleteCollection() {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.DELETE_COLLECTION, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      index: this.indexCollectionFilter
    });

    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_COLLECTION_ITEM, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      collection: this.collectionField[0]
    });
    this.$emit(
      "deleteCollection",
      this.indexCollectionFilter,
      this.collectionField[0]
    );
  }

  sendDataToStoreReadyToChart(
    xAxis: [],
    data: [],
    groups: {},
    indexCollection: number,
    groupBy: DynamicSelectData[],
    seeBy: DynamicSelectData[]
  ) {
    const chartData = {
      chartName: this.chartName,
      xAxis,
      data,
      groups
    };

    const prepareData = {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: indexCollection,
      groupBy: groupBy,
      seeBy: seeBy,
      chartName: "",
      chartData,
      chartColor: "",
      notFound: false
    };

    if (this.indexCollectionFilter == indexCollection) {
      prepareData.chartName = this.chartName;
      prepareData.chartColor = this.chartColor.hex;
    }

    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_CONFIG_CHART, prepareData);
  }

  configChart() {
    this.showDialogConfigChart = true;
  }

  groupByOptions() {
    const collection = this.collectionsOptions.find(
      collection => collection.name == this.collectionField[0].name
    );
    if (collection) {
      this.groupByOptionsConfig.listAll = collection.fields?.map(
        (item: Field) => {
          return {
            id: item.field,
            name: item.visualField,
            type: item.type
          };
        }
      ) as DynamicSelectData[];
    }
  }

  async makeQuery(editMode?: boolean) {
    this.showCharts = false;
    const filters: FilterItemOfQuery[] = [];
    const collections = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections;

    for (const [indexCollection, collection] of collections.entries()) {
      if (editMode && indexCollection > this.indexCollectionFilter) break;
      for (const filter of collection.filters) {
        console.log("filter", filter);
        if (!(filter.field[0] as FilterField)) return;
        filters.push({
          view: collection.collection[0].id,
          field: (filter.field[0] as FilterField).id,
          operator: ((filter.operator[0] as unknown) as DynamicSelectData).id,
          value: this.fixValues(filter)
        });
      }
    }
    this.buildEveryQuery(collections, filters);
    this.updateTagsQueries(
      this.sectionsOfDashboardStore[this.indexSectionOfDashboard].tags,
      filters
    );
  }

  async updateTagsQueries(
    tags: IndicatorOrTag[],
    filters: FilterItemOfQuery[]
  ) {
    try {
      for (const [index, tag] of tags.entries()) {
        const copyOfTag = lodash.cloneDeep(tag);

        if (!copyOfTag.query) continue;
        copyOfTag.query.filters = filters;

        const dataToChartResponse = await this.bqDashboardService.getDataToChart(
          copyOfTag.query
        );

        if (dataToChartResponse.code !== Http.Found) {
          continue;
        }

        copyOfTag.value = Number(
          (Object.values(dataToChartResponse.data[0])[0] as number).toFixed(2)
        );

        store.commit(DASHBOARD_TEMPLATE_EVENTS.UPDATE_TAG, {
          indexSectionOfDashboard: this.indexSectionOfDashboard,
          index: index,
          tag: copyOfTag
        });
      }
    } catch (error) {
      // Error handling
    }
  }

  buildEveryQuery(
    collections: CollectionFilter[],
    filters: FilterItemOfQuery[]
  ) {
    for (const [indexCollection, collection] of collections.entries()) {
      this.manageAsynQuerys(collection, filters, indexCollection);
    }
  }

  async manageAsynQuerys(
    collection: CollectionFilter,
    filters: FilterItemOfQuery[],
    indexCollection: number
  ) {
    const query = {
      selectFields: {
        fields: [],
        agregations: []
      },
      seeBy: this.fixSeeBy(collection.seeBy as DynamicSelectData[]),
      principalView: collection.collection[0].id,
      filters: filters,
      groupFields: [{}]
    };

    if (indexCollection == this.indexCollectionFilter) {
      query.groupFields = this.fixGroupBy(
        this.groupBy as DynamicSelectData[],
        collection
      );

      if (this.seeBy.length > 0) {
        query.seeBy = this.seeBy[0].id;
      }
    } else {
      query.groupFields = this.fixGroupBy(
        collection.groupBy as DynamicSelectData[],
        collection
      );
    }

    if (query.groupFields.length == 0) {
      return;
    }

    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_QUERY, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: indexCollection,
      query: query
    });

    this.searching = true;
    const dataToChartResponse = await this.bqDashboardService.getDataToChart(
      query
    );
    this.searching = false;

    if (dataToChartResponse.code !== Http.Found) {
      this.foundData = false;
      this.showCharts = false;
      store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_CONFIG_CHART, {
        notFound: true,
        indexSectionOfDashboard: this.indexSectionOfDashboard,
        indexCollectionFilter: indexCollection
      });
    }
    this.foundData = true;

    if (this.indexCollectionFilter == indexCollection) {
      this.propertiesToChart = {
        indexSectionOfDashboard: this.indexSectionOfDashboard,
        indexCollectionFilter: this.indexCollectionFilter,
        groupBy: this.groupBy,
        chartType: this.chartType,
        chartColor: this.chartColor
      };
      this.showCharts = true;
    }

    this.onChartTypeChanged(this.chartType);

    this.sendDataToStoreReadyToChart(
      dataToChartResponse.data.xAxisValues,
      dataToChartResponse.data.series,
      dataToChartResponse.data.groups,
      indexCollection,
      this.indexCollectionFilter == indexCollection
        ? this.groupBy
        : (collection.groupBy as DynamicSelectData[]),
      this.indexCollectionFilter == indexCollection
        ? this.seeBy
        : (collection.seeBy as DynamicSelectData[])
    );
  }

  fixSeeBy(seeBy: DynamicSelectData[]) {
    if (seeBy && seeBy.length > 0) {
      return seeBy[0].id;
    }
    return "";
  }

  async makeQueryWhenIsPreloading(query: Query) {
    try {
      this.searching = true;
      const dataToChartResponse = await this.bqDashboardService.getDataToChart(
        query
      );

      this.searching = false;
      if (dataToChartResponse.code !== Http.Found) {
        this.foundData = false;
        this.showCharts = false;
        return;
      }
      this.foundData = true;
      this.propertiesToChart = {
        indexSectionOfDashboard: this.indexSectionOfDashboard,
        indexCollectionFilter: this.indexCollectionFilter,
        groupBy: this.groupBy,
        chartType: this.chartType,
        chartColor: this.chartColor
      };

      this.onChartTypeChanged(this.chartType);

      this.showCharts = true;
      this.sendDataToStoreReadyToChart(
        dataToChartResponse.data.xAxisValues,
        dataToChartResponse.data.series,
        dataToChartResponse.data.groups,
        this.indexCollectionFilter,
        this.groupBy,
        this.seeBy
      );
    } catch (error) {
      // Error handling
    }
  }

  fixGroupBy(groupBy: DynamicSelectData[], collection: CollectionFilter) {
    return groupBy
      .sort((a, b) =>
        a.type === DATA_TYPE.TIME_STAMP && b.type !== DATA_TYPE.TIME_STAMP
          ? -1
          : a.type !== DATA_TYPE.TIME_STAMP && b.type === DATA_TYPE.TIME_STAMP
          ? 1
          : 0
      )
      .map(groupBy => ({
        view: collection.collection[0].id,
        field: (groupBy as DynamicSelectData).id
      }));
  }

  fixValues(filter: FilterOfCollection): string[] | number[] | [][] {
    if ((filter.field[0] as FilterField).id == "priceLevel") {
      return this.fixPriceLevelValues(filter) as string[];
    }

    if ((filter.field[0] as FilterField).type == DATA_TYPE.TIME_UNIT) {
      return [
        `${filter.value} ${(filter.field[0] as FilterField).description!}`
      ];
    }

    if (["text", "number"].includes((filter.field[0] as FilterField).type)) {
      return [(filter.value as unknown) as string];
    }

    return filter.value.map((value: DynamicSelectData | string) => {
      if ((value as DynamicSelectData)?.id == FIELD_WITHOUT_DATA_ID) {
        return "";
      }
      return (value as DynamicSelectData).id || (value as string);
    });
  }

  fixPriceLevelValues(filter: FilterOfCollection) {
    const filters = this.sectionsOfDashboardStore[this.indexSectionOfDashboard]
      .collections[this.indexCollectionFilter].filters;

    const cupsField = filters.find(
      filter => (filter.field[0] as FilterField).id === "cups"
    );

    const clientsNames = filter.value.map(
      (value: DynamicSelectData) => value.name
    );

    let clientsIds: string[] = [];
    (cupsField as FilterOfCollection).value.forEach(
      (value: DynamicSelectData) => {
        const clients = Object.entries(value.fields)
          .filter(item => {
            return clientsNames.includes(
              (item[1] as { name: string; price: string }).name
            );
          })
          .map((item: [string, unknown]) => item[0]);

        clientsIds = Array.from(
          new Set<string>([...clientsIds, ...clients])
        );
      }
    );

    return clientsIds;
  }

  @Watch("groupBy")
  onGroupByChange() {
    this.reloadChartTypeMenu++;
    if (
      this.groupBy.filter(groupBy => groupBy.type == DATA_TYPE.TIME_STAMP)
        .length > 0
    ) {
      this.showSeeBy = true;
      return;
    }
    this.showSeeBy = false;
  }

  cancelConfigChart() {
    this.showDialogConfigChart = false;
  }

  onChartTypeChanged(newChartType: string) {
    if (!newChartType) {
      if (this.groupBy.length > 1) {
        newChartType = DASHBOARD_CHART_TYPES.filter(e => e.stacked)[0].value;
      } else {
        newChartType = DASHBOARD_CHART_TYPES.filter(e => !e.stacked)[0].value;
      }
    }
    this.propertiesToChart = {
      ...this.propertiesToChart,
      chartType: newChartType
    };

    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_CHART_TYPE, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: this.indexCollectionFilter,
      chartType: newChartType
    });
  }

  @Watch("eventChart")
  changeEventChart() {
    try {
      if (
        this.indexCollectionFilter != this.eventChart.indexCollection ||
        this.indexSectionOfDashboard != this.eventChart.indexSection
      ) {
        return;
      }
      const groupByIds = this.groupBy.map(item => item.id);
      const newFilters = this.collectionField[0].fields.filter((option: any) =>
        groupByIds.includes(option.field)
      );

      if (newFilters.length == 0) {
        return;
      }

      const filtersCopy = lodash.cloneDeep(
        this.sectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
          this.indexCollectionFilter
        ].filters
      );

      newFilters.forEach((item: any) => {
        const indexGroup = this.groupBy.findIndex(
          groupBy => groupBy.id == item.field
        );

        let operator = [{ id: "=", name: "=" }];
        let value:
          | { id: string; name: string; fields?: object }[]
          | string[] = [
          {
            id: this.eventChart.values[indexGroup],
            name: this.eventChart.values[indexGroup]
          }
        ] as { id: string; name: string }[];

        if (item.type == DATA_TYPE.TIME_STAMP && this.seeBy.length > 0) {
          operator = [{ id: "BETWEEN", name: "Entre" }];
          value = this.fixRange(this.eventChart.values as string[], this.seeBy);
        }

        if (item.type == DATA_TYPE.TIME_UNIT) {
          value = [this.eventChart.values[indexGroup]];
        }

        const filterToAdd = {
          field: [
            {
              child: item.child,
              id: item.field,
              type: item.type,
              idList: item.idList,
              name: item.visualField,
              operators: item.operators
            }
          ],
          operator,
          value,
          filterFromChart: true
        };

        const indexFilter = filtersCopy.findIndex(
          item => (item.field[0] as FilterField).id == filterToAdd.field[0].id
        );
        if (indexFilter >= 0) {
          const existingValue = filtersCopy[indexFilter].value[0 as number];
          if (
            typeof existingValue === "object" &&
            existingValue !== null &&
            "fields" in existingValue
          ) {
            (filterToAdd.value[0] as {
              id: string;
              name: string;
              fields?: object;
            }).fields = existingValue.fields;
          }

          filtersCopy[
            indexFilter
          ] = (filterToAdd as unknown) as FilterOfCollection;
        } else {
          filtersCopy.push((filterToAdd as unknown) as FilterOfCollection);
        }
      });

      this.filters = filtersCopy;
      this.chartType = this.eventChart.chartType;
    } catch (error) {
      // Error handling
    }
  }

  fixRange(values: string[], seeBy: DynamicSelectData[]) {
    for (const element of seeBy) {
      return this[`calculateRange${element.id}` as keyof CollectionOfSection](
        values[0]
      );
    }
  }

  calculateRangemonth(value: string) {
    const [year, month] = value.split("-").map(Number);
    const start = `${year}-${String(month).padStart(2, "0")}-01`;
    const lastDay = new Date(year, month, 0).getDate();
    const end = `${year}-${String(month).padStart(2, "0")}-${String(
      lastDay
    ).padStart(2, "0")}`;

    return [start, end];
  }

  /*   calculateRangeweek(value: string) {
    // Week calculation
  }
  calculateRangeday(value: string) {
    // Day calculation
  } */

  calculateRangeyear(value: string) {
    const start = `${value}-01-01`;
    const end = `${value}-12-31`;
    return [start, end];
  }

  addNewField(data: { field: string; visualField: string; fields: any[] }) {
    console.log("addNewField", data);
    console.log("this.collectionField", this.collectionField);
    this.collectionField[0].fields.push(data);
  }

  removeField(data: string) {
    console.log("removeField", data);
    this.collectionField[0].fields = this.collectionField[0].fields.filter(
      (item: any) => item.field !== data
    );
  }
}
